import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, Facebook, MessageCircle, Send, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { STORE_NAME } from "@/lib/pizzeria";

const TEXT = `Ordina le pizze di ${STORE_NAME} direttamente dall'app!`;

export const ShareButton = ({ className = "", variant = "default", label = "Condividi l'App" }) => {
  const [open, setOpen] = useState(false);
  const url = window.location.origin;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: STORE_NAME, text: TEXT, url });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    setOpen(true);
  };
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato");
    } catch {
      window.prompt("Copia il link:", url);
    }
  };
  const links = [
    ["WhatsApp", MessageCircle, `https://wa.me/?text=${encodeURIComponent(`${TEXT} ${url}`)}`, "bg-[#25D366]"],
    ["Telegram", Send, `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(TEXT)}`, "bg-[#229ED9]"],
    ["Facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "bg-[#1877F2]"],
  ];

  return (
    <>
      <Button onClick={share} variant={variant} className={`rounded-full gap-2 ${className}`} data-testid="share-app-button">
        <Share2 className="h-4 w-4" />{label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm bg-background" data-testid="share-dialog">
          <DialogTitle className="font-serif text-2xl">Condividi l'App</DialogTitle>
          <DialogDescription>Invia il link a chi vuoi, oppure fai inquadrare il QR Code.</DialogDescription>
          <div className="grid grid-cols-3 gap-2">
            {links.map(([name, Icon, href, bg]) => (
              <a key={name} href={href} target="_blank" rel="noopener noreferrer" className={`${bg} text-white rounded-2xl py-3 flex flex-col items-center gap-1 text-xs font-semibold`} data-testid={`share-${name.toLowerCase()}`}>
                <Icon className="h-5 w-5" />{name}
              </a>
            ))}
          </div>
          <Button variant="outline" onClick={copy} className="rounded-full gap-2" data-testid="share-copy-link"><Copy className="h-4 w-4" />Copia link</Button>
          <div className="mx-auto rounded-2xl bg-white p-4 border border-border" data-testid="share-qr">
            <QRCodeCanvas value={url} size={180} fgColor="#1F1A17" />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
